import {Sidebar} from "primereact/sidebar";
import React, {useContext, useRef} from "react";
import {LayoutContext} from "./context/LayoutContext";
import useStore from "../hooks/useStore";
import callToast, {catchError} from "../utils/helper";
import {webInfo} from "../utils/webInfo";
import {Toast} from "primereact/toast";
import {useNavigate} from "react-router-dom";

const AppProfileSidebar = () => {
    const {accessToken} = useStore()
    const toast:any = useRef<Toast | null>(null);
    const navigate = useNavigate()
    const { layoutState, setLayoutState } = useContext(LayoutContext);
    const onProfileSidebarHide = () => {
        setLayoutState((prevState) => ({
            ...prevState,
            profileSidebarVisible: false,
        }));
    };

    const signOut = async () => {
        try {
            const response = await fetch(`${webInfo.baseUrl}/api/admin/logout`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            if (!response.ok) {
                const {errors} = await response.json();
                errors?.forEach((error: any) => {
                    callToast(toast,false,error)
                })

            }else {
                callToast(toast,false,"Logged out successfully")
                navigate("/auth/login")
            }
        }catch (e) {
            catchError(e)
        }
    }



    return (
        <Sidebar
            visible={layoutState.profileSidebarVisible}
            onHide={onProfileSidebarHide}
            position="right"
            className="layout-profile-sidebar w-full sm:w-25rem"
        >
            <Toast ref={toast}/>
            <div className="flex flex-column mx-auto md:mx-0">
                {/*<div className="mb-5">*/}
                {/*    <h4 className="text-primary font-medium mb-0">{user?.name}</h4>*/}
                {/*    <p>{user?.email}</p>*/}
                {/*</div>*/}

                <ul className="list-none m-0 p-0">
                    <li>
                        <button className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                            <span>
                                <i className="pi pi-power-off text-xl text-primary"></i>
                            </span>
                            <div onClick={signOut} className="ml-3">
                                <span className="mb-2 font-semibold">
                                    Sign Out
                                </span>
                            </div>
                        </button>
                    </li>
                </ul>
            </div>
        </Sidebar>
    );
};

export default AppProfileSidebar;
